import { render, staticRenderFns } from "./apkAdd.vue?vue&type=template&id=038974a2&"
import script from "./apkAdd.vue?vue&type=script&lang=js&"
export * from "./apkAdd.vue?vue&type=script&lang=js&"
import style0 from "./apkAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports